import { useSuspenseQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/legacy/utils/error-handling/throwifApiError'
import { ExtOpsApiClient, ExtOpsResponse } from '@omnea-app/packages/universal/extopsApiClient/extopsApiClient'

type ListExtOpsIntegrationsResponseType = ExtOpsResponse<'/account/integrations', 'get'>
type ListExtOpsIntegrationsData = ListExtOpsIntegrationsResponseType['data'] | null

export type CustomIntegration = NonNullable<ListExtOpsIntegrationsData>['customIntegrations'][number]

type ListExtOpsIntegrationsError = ListExtOpsIntegrationsResponseType['error']
export type ExtOpsIntegration = NonNullable<ListExtOpsIntegrationsData>['integrations'][number]

export const listExtOpsIntegrationsQueryKey = ['extOpsIntegrations']

const useQueryFn = () => {
  const { getToken } = useAuthenticatedUser()
  return async () => {
    const token = await getToken()
    const apiClient = new ExtOpsApiClient({ authorization: token })
    try {
      const { data, error } = await apiClient.GET('/account/integrations', {})
      throwIfApiError(error)
      return data
    } catch {
      // Catch errors and return null so we can fallback to default data in hook
      return null
    }
  }
}

export const useListExtOpsIntegrations = () => {
  const data = useSuspenseQuery<ListExtOpsIntegrationsData, ListExtOpsIntegrationsError>({
    queryKey: [listExtOpsIntegrationsQueryKey],
    queryFn: useQueryFn(),
  }).data

  return {
    integrations: data?.integrations ?? [],
    customIntegrations: data?.customIntegrations ?? [],
  }
}
